// extracted by mini-css-extract-plugin
module.exports = {"mediaFormInput":"EditTaskModal_mediaFormInput__2WfLV","deleteIcon":"EditTaskModal_deleteIcon__1LnIu","fileSelector":"EditTaskModal_fileSelector__1Lzm5"};